import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, makeStyles, Typography } from "@material-ui/core";
import TableChartIcon from "@material-ui/icons/TableChart";
import AssessmentIcon from "@material-ui/icons/Assessment";
import SectionTitle from "../../HelpDialog/SectionTitle";
import ActionDialog from "../../../ActionDialog";
import TipBox from "../../../TipBox";
import HeaderPageItem from "../../../../../custom/HeaderPageItem";
import HelpIcon from "@material-ui/icons/Help";
import UsersFiltersDescription from "../UserFiltersDescription";
import HelpItemsList from "../../HelpDialog/HelpItemsList";
import TableActionsHelp from "../../HelpDialog/TableActionHelp";

const useClasses = makeStyles((theme) => ({
  filterContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  section: {
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

const summaryMessages = [
  "app.report.users.summary.totalUsers.byUser",
  "app.report.users.summary.totalCustody.byUser",
  "app.report.users.summary.average.byUser",
  "app.report.users.summary.avgDuration.byUser",
];

const HeaderReportUsers = ({ title, userFilters }) => {
  const classes = useClasses();
  const [openDialog, setOpenDialog] = React.useState(false);

  return (
    <>
      <HeaderPageItem
        title={title}
        showBackButton
        useHistoryGoBack
        onMore={() => setOpenDialog(true)}
        IconMore={HelpIcon}
      />
      <ActionDialog
        open={openDialog}
        title={title}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        textButtonCancel="app.close"
        enableConfirmButton={false}
      >
        <Box className={classes.section}>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.description.1" />
          </Typography>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.description.2" />
          </Typography>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.description.3" />
          </Typography>
          <TipBox>
            <FormattedMessage id="app.report.users.alert" />
          </TipBox>
        </Box>

        <UsersFiltersDescription
          userFilters={userFilters}
          classes={classes}
        />

        <Box className={classes.section}>
          <SectionTitle icon={AssessmentIcon}>
            <FormattedMessage id="app.report.users.section.summary" />
          </SectionTitle>

          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.summary.description" />
          </Typography>

          <HelpItemsList messages={summaryMessages} />

          <TipBox>
            <FormattedMessage id="app.report.users.summary.alert" />
          </TipBox>
        </Box>

        <Box className={classes.section}>
          <SectionTitle icon={TableChartIcon}>
            <FormattedMessage id="app.report.users.section.table" />
          </SectionTitle>

          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.table.description" />
          </Typography>
        </Box>
        <TableActionsHelp
          showCopy
          showColumns
        />
      </ActionDialog>
    </>
  );
};

export default React.memo(HeaderReportUsers);
